import React from 'react';

const FilledButton = ({ label, onClick, disabled = false,className='' }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`px-4 py-2 bg-blue-500 text-white font-semibold capitalize ${className} rounded-lg shadow hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 transition ease-in-out duration-150 ${
        disabled ? 'opacity-50 cursor-not-allowed' : ''
      }`}
    >{label}</button>
  );
};

export default FilledButton;
